import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@jisr-hr/design-system'

const InfoText = ({ label, color }) => (
  <Text
    typography="paragraph14"
    color={color}
  >
    {label}
  </Text>
)

InfoText.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
}

export default InfoText
